import { createSelector } from 'reselect';
import { getIsUserImpersonated } from '../AuthSelector';
export const getSecurityPhoneNumber = state => state.securityPhoneNumber;
export const getCanModifySecurityPhoneNumber = createSelector([getIsUserImpersonated], isImpersonated => !isImpersonated);